import templateUrl from './onboarding-dashboard-items.component.html';
import { InfoModal } from '../info-modal/info-modal.component';
import { OnboardingUpdateModal } from '../onboarding-update-modal/onboarding-update-modal.component';
import { OnboardingRequestReviewModal } from '../onboarding-request-review-modal/onboarding-request-review-modal.component';


export const DashboardItemsOnboardingComponent = {
    templateUrl,
    controller: OnboardingDashboardItemsController,
    controllerAs: "vm",
    bindings: {
        filters: "<",
        onChangeFilters: "&",
        applications: "<",
        onSetSort: "&",
        isSortingByField: "&",
        isEmployee: "<",
        isOwner: "<",
        isManager: "<",
        isHJEE: "<",
        onboardEmployee:"&",
        onClearClicked: "&",
        resendOnboardingEmail: "&",
        fillApplication: "&",
        checkApplication: "&",
        updateEmployee: "&",
        requestChangesModal: "&",
        onComment: "&",
        approveApplication: "&",
        terminateApplication: "&",
        rejectApplication: "&",
        rehireEmployee: "&",
        triggerOnboardingForInactive: "&",
        approveApplicationForPaper: "&",
        navigateToLegacyProfile: "&",
        changeToPaper: "&",
        changeToOnline: "&"
    }
};


function OnboardingDashboardItemsController(utilityService, onboardingDocumentService, onboardingActionPolicy, $state, $uibModal) {
    'ngInject';
    const vm = this;
    vm.setSort = setSort;
    vm.onSortingByField = onSortingByField;
    vm.sortClass = sortClass;
    vm.getSubmittedForm = getSubmittedForm;
    vm.comment = comment;
    vm.terminateApp = terminateApp;
    vm.rehireApp = rehireApp;
    vm.openUpdateModal = openUpdateModal;
    vm.openRequestReviewModal = openRequestReviewModal;

    // Delegate the shared label/status helpers to the central policy service so both
    // the dashboard and the employee portal use one implementation (was duplicated).
    vm.getButtonTitle = (requestTypeId, app) => onboardingActionPolicy.getButtonTitle(requestTypeId, app);
    vm.updateFormStatus = (app, type) => onboardingActionPolicy.updateFormStatus(app, type);
    vm.readyForApproval = (app) => onboardingActionPolicy.readyForApproval(app);
    vm.getDeleteLabel = (app) => onboardingActionPolicy.getDeleteLabel(app);

    vm.$onInit = function () {
        // Build the action context once; role flags are static for this view.
        const ctx = {
            view: 'dashboard',
            isOwner: !!vm.isOwner,
            isEmployee: !!vm.isEmployee,
            isManager: !!vm.isManager,
            isHJEE: !!vm.isHJEE
        };
        // Single entry point the template uses to gate every flow action button.
        vm.actions = {
            isVisible: (action, app) => onboardingActionPolicy.isVisible(action, app, ctx),
            isDisabled: (action, app) => onboardingActionPolicy.isDisabled(action, app, ctx),
            label: (action, app) => onboardingActionPolicy.label(action, app, ctx)
        };
    }
    // Derive the active sort from filters.SortFields (the value actually sent to the
    // server), so the header indicator/arrow always match the applied sort - including
    // after a reload. Avoids depending on parent state that can drift out of sync.
    function currentSort() {
        const sf = vm.filters && vm.filters.SortFields && vm.filters.SortFields[0];
        if (!sf) return { field: null, dir: 1 };
        return sf.charAt(0) === "-"
            ? { field: sf.substring(1), dir: -1 }
            : { field: sf, dir: 1 };
    }

    function onSortingByField(field) {
        return currentSort().field === field;
    }

    function comment(applicationId) {
        return vm.onComment({ applicationId: applicationId });
    }

    function setSort(field) {
        return vm.onSetSort({ field: field });
    }

    function sortClass() {
        return currentSort().dir === -1 ? "fas fa-sort-amount-down" : "fas fa-sort-amount-down-alt";
    }

    function terminateApp(app) {
        if (app.IsTelemapperLinked) {
            alert('Please be aware that your company is linked with Telemapper and terminations have to be processed in Telemapper.');
        } else {
            var confirmDelete = confirm("Please confirm that you would like to terminate this onboarding application.");
            if (!confirmDelete) {
                return; // cancel the action
            }
            // delete profile
            return vm.terminateApplication({ appNo: app.ApplicationNumber });
        }
    }

    function rehireApp(app) {
        if (app.IsTelemapperLinked) {
            alert('Please be aware that your company is linked with Telemapper and rehires have to be processed in Telemapper.');
        } else {
            //var confirmRehire = confirm("Please confirm that you would like to rehire this onboarding application.");
            //if (!confirmRehire) {
            //    return; // cancel the action
            //}
            // rehire profile
            return vm.rehireEmployee({ employeeID: app.EmployeeId });
        }
    }

    // APEX-977 - employee profile-level Update. Opens the two-stage update modal; on confirm,
    // unlocks the chosen forms via UpdateChangeFormMapping (isOwner=false) then reloads the grid.
    function openUpdateModal(app) {
        return $uibModal.open({
            ...OnboardingUpdateModal,
            resolve: {
                app: () => app,
                is1099: () => app.Is1099,
                paper: () => app.ApplicationStatus === 'Paper'
            }
        }).result.then(function (result) {
            if (!result || !result.formIds || !result.formIds.length) {
                return;
            }
            const data = result.formIds.map((id) => ({ FormID: id }));
            const update = onboardingDocumentService
                .updateFormChange(app.ApplicationNumber, data, false, false)
                .then(function () {
                    $state.reload();
                });
            return utilityService.showLoadingUntilResolved(
                utilityService.alertOnError(update, "Updating failed"));
        }, function () {
            // dismissed (Cancel / X) - no changes
        });
    }

    // APEX-978 - owner pushes selected forms back to the employee for review + a comment.
    function openRequestReviewModal(app) {
        return $uibModal.open({
            ...OnboardingRequestReviewModal,
            resolve: {
                app: () => app,
                is1099: () => app.Is1099,
                paper: () => app.ApplicationStatus === 'Paper' // Paper: modal restricts to DD only
            }
        }).result.then(function (result) {
            if (!result || !result.formIds || !result.formIds.length) {
                return;
            }
            const update = onboardingDocumentService
                .requestReview(app.EmployeeId, result.formIds, result.comment, result.option)
                .then(function () {
                    $state.reload();
                });
            return utilityService.showLoadingUntilResolved(
                utilityService.alertOnError(update, "Request Review failed"));
        }, function () {
            // dismissed (Cancel / X) - no changes
        });
    }

    function getSubmittedForm(requestTypeId, app) {
        vm.showInfoModal = false;
        if (!vm.ownerView) {
            switch (requestTypeId) {
                case "5":
                    if (app.FederalW4 !== "Approved") {
                        vm.showInfoModal = true;
                    }
                    break;
                case "-2":
                    if (app.W9 !== "Approved") {
                        vm.showInfoModal = true;
                    }
                    break;
                case "3":
                    if (app.I9Form !== "Approved") {
                        vm.showInfoModal = true;
                    }
                    break;
                case "2":
                    if (app.ProvinceW4 !== "Approved") {
                        vm.showInfoModal = true;
                    }
                    break;
            }
        }
        if (vm.showInfoModal) {
            return $uibModal.open({
                ...InfoModal,
                resolve: {
                    notification: () => {
                        return "You are currently trying to download a partial completed form. Once approved by the company, your fully completed form will be available.";
                    },
                    showCancel: () => {
                        return true;
                    },
                    continue: () => {
                        return 'Download Incomplete';
                    }
                },
                size: 'sm',
                backdrop: 'static'
            }).result.then((res) => {
                // ? USER CLICKED SUBMIT / CONTINUE
                if (res === 'ok') {
                    const taxForm = onboardingDocumentService.getTaxForm(app.EmployeeId, requestTypeId);
                    utilityService.showLoadingUntilResolved(
                        utilityService.alertOnError(taxForm, "Download failed"))
                        .then(() => {
                            utilityService.hideLoading();
                        });
                }
            });
        } else {
            const taxForm = onboardingDocumentService.getTaxForm(app.EmployeeId, requestTypeId);
            /*return onboardingDocumentService.getTaxForm(vm.employee.UserName, requestTypeId);*/
            utilityService.showLoadingUntilResolved(
                utilityService.alertOnError(taxForm, "Download failed"))
                .then(() => {
                    utilityService.hideLoading();
                });
        }

    }

}
